"use client"

import { useEffect } from "react";

export const Root = ({ children }: { children: React.ReactNode }) => {
    return (
        <html lang="fr"
            /*suppressHydrationWarning*/
            data-theme="light-neutral"
            onMouseUp={(e) => {
                if (e.button === 2) {
                    e.preventDefault();
                }
            }}
            onClick={(e) => {
                if (e.button === 2) {
                    e.preventDefault();
                }
            }}
            onContextMenu={(e) => {
                if (e.button === 2) {
                    e.preventDefault();
                }
            }}
        >
            {children}
        </html>
    );
};